import React, { Component } from 'react';
import ReactTable from "react-table";
import couterpart from 'counterpart';
// import ReactTablePagination from './PaginationComponent';
import {ToastsContainer, ToastsStore} from 'react-toasts';

import MenuComponent2 from './MenuComponent2';
import FileUploader from './FileUploader';
import WorkOrderUtil from '../utilities/WorkOrderUtil';

import ImportFileService from '../services/ImportFileService';
import AuthenticationService from '../services/AuthenticationService';

import "react-table/react-table.css";
import "../css/style.css";
import {MdDeleteForever} from 'react-icons/md';
import { ICON_COLOR } from '../icon';


class ImportFileList extends Component {
  constructor () {
    super();
    const action = couterpart.translate('action');

    this.state = {
      importedContentInfoList: [],
      columns : [{
            Header: couterpart.translate('imported_file_id'),
            accessor: 'id',
            width: 200
        },{
            Header: couterpart.translate('imported_file_name'),
            accessor: 'fileName'
        },{
            Header: couterpart.translate('imported_date'),
            accessor: 'createdAt',
            filterable: false,
            Cell: props => WorkOrderUtil.formatShortDisplayDateMMddyyyy2(props.value)                        
        },{
            Header: action,
            accessor: 'action',
            width: 100,
            Cell: row =>(
                <div>
                    {this.renderButtons(row)}
                </div>
            )
      }]
    };
  }

  renderButtons(row){
    const button_delete = couterpart.translate('button_delete');
    if (AuthenticationService.isAdmin() || AuthenticationService.isService()){
      return(
        <div><button className="myButton" onClick={() => this.handleDelete(row.original)}>
        <MdDeleteForever color={ICON_COLOR}/>&nbsp;
        {button_delete}</button></div>
      );
    }
  }

  componentDidMount () {
    ImportFileService.retrieveAllImportedFiles().then(data => {
      if (data.message === undefined){
        this.setState({ importedContentInfoList:  data});
      }else{
        this.setState({ orders:  []})
        ToastsStore.error(data.message);
      }
    });
  }

  handleDelete(e){
    ImportFileService.delete(e.id).then(data =>{
      ImportFileService.retrieveAllImportedFiles().then(data => {
        if (data.message === undefined){
          this.setState({ importedContentInfoList:  data});
        }else{
          this.setState({ orders:  []})
          ToastsStore.error(data.message);
        }
      });
    });
  }

  handleUpdate(){
    ImportFileService.retrieveAllImportedFiles().then(data => {
      if (data.message === undefined){
        this.setState({ importedContentInfoList:  data});
      }
    });
  }

  render() {
    if (!AuthenticationService.isAdmin() && !AuthenticationService.isService()){
      return (<div>Unauthorized access.</div>);
    }
    return (
          <div>
              <MenuComponent2/>
              <ToastsContainer store={ToastsStore} position="bottom_center" />
              <ReactTable
                NoDataComponent={() => null} 
                // PaginationComponent={ReactTablePagination}
                previousText={"<"}
                nextText={">"}
                data={this.state.importedContentInfoList}
                columns={this.state.columns}
                defaultPageSize = {10}
                showPageSizeOptions = {true}
                pageSizeOptions = {[3, 5, 10, 20]}
                getTrProps={(state, rowInfo, column) => { 
                  if (rowInfo && rowInfo.row) {
                    return {
                      onClick: (e) => {
                        this.setState({
                          selected: rowInfo.index,
                          importedFileId: rowInfo.original.id
                        })
                      },
                      style: {
                        background: rowInfo.index === this.state.selected ? '#DCDCDC' : 'white',
                        color: rowInfo.index === this.state.selected ? 'white' : 'black'
                      }
                    }
                  }else{
                    return {}
                  }
                }
              }
              />
              <FileUploader handleUpdate={this.handleUpdate.bind(this)}/>
          </div>      
    )
  }
}

export default ImportFileList;